import { AppModal } from '@/components/app-modal'
import { ModalEnum } from '@/interfaces'
import { useStores } from '@/stores/RootStoreContext'
import { Form } from 'antd'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import Footer from './footer'
import Header from './header'
import StepOne from './stepOne'
import StepThree from './stepThree'
import StepFour from './stepFour'
import StepTwo from './stepTwo'

const modalStyles = {
  content: {
    borderRadius: 10,
    padding: '40px',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
}

const DowngradePlanModal = observer(() => {
  const { modalStore } = useStores()
  const [form] = Form.useForm()

  const MODAL_ID = ModalEnum.DOWNGRADE_PLAN

  // Possible steps: "planComparison", "reason", "password", "confirmation"
  const [step, setStep] = useState('planComparison')

  const modalIsOpen = computed(() => modalStore.modalIsOpen(MODAL_ID)).get()

  const onCancel = () => {
    modalStore.closeModal(MODAL_ID)
  }

  const onFinish = (values) => {
    const data = form.getFieldsValue(true)
    console.log('Downgrade data:', data)
    // TODO: Implementar lógica de downgrade
    setStep('confirmation')
  }

  const handleConfirm = () => {
    if (step === 'planComparison') {
      setStep('reason')
    } else if (step === 'reason') {
      setStep('password')
    } else if (step === 'password') {
      form.submit()
    }
  }

  const handleBack = () => {
    if (step === 'password') {
      setStep('reason')
    } else if (step === 'reason') {
      setStep('planComparison')
    }
  }

  const StepComponent = {
    planComparison: StepOne,
    reason: StepTwo,
    password: StepThree,
    confirmation: StepFour,
  }[step]

  useEffect(() => {
    // Reset form and step when modal is closed
    if (!modalIsOpen) {
      form.resetFields()
      setStep('planComparison')
    }
  }, [modalIsOpen, form])

  const showForm = step === 'reason'

  return (
    <AppModal
      modalId={MODAL_ID}
      width={{ md: '850px' }}
      onCancel={onCancel}
      destroyOnHidden
      footer={<Footer step={step} onConfirm={handleConfirm} onBack={handleBack} />}
      closable
      styles={modalStyles}
    >
      <Header step={step} />

      <div className={showForm ? 'mt-12!' : ''}>
        <Form
          form={form}
          name="downgradeForm"
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          validateMessages={{ required: '' }}
        >
          <StepComponent />
        </Form>
      </div>
    </AppModal>
  )
})

export default DowngradePlanModal
